import { render, staticRenderFns } from "./page-content.vue?vue&type=template&id=dede4e7a&scoped=true&"
import script from "./page-content.vue?vue&type=script&lang=js&"
export * from "./page-content.vue?vue&type=script&lang=js&"
import style0 from "./page-content.vue?vue&type=style&index=0&id=dede4e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dede4e7a",
  null
  
)

export default component.exports